import { Toolbar, ToolbarButton, Label } from '@fluentui/react-components';
import {
  ArrowNext24Filled,
  ArrowPrevious24Filled,
  ChevronLeft24Filled,
  ChevronRight24Filled,
} from '@fluentui/react-icons';
import React from 'react';

// ============================================================================
// Types
// ============================================================================

export interface PaginationBarProps {
  /** Current page number (1-indexed) */
  page: number;
  /** Total number of pages */
  pageCount: number;
  /** Whether current page is the last page */
  isLastPage: boolean;
  /** Go to first page */
  onFirst: () => void;
  /** Go to previous page */
  onPrev: () => void;
  /** Go to next page */
  onNext: () => void;
  /** Go to last page */
  onLast: () => void;
  /** Extra content to render after pagination buttons */
  children?: React.ReactNode;
}

// ============================================================================
// Component
// ============================================================================

const PaginationBar: React.FC<PaginationBarProps> = ({
  page,
  pageCount,
  isLastPage,
  onFirst,
  onPrev,
  onNext,
  onLast,
  children,
}) => {
  const isFirstPage = page === 1;

  return (
    <Toolbar aria-label="Pagination" size="small">
      <ToolbarButton
        aria-label="First page"
        icon={<ArrowPrevious24Filled />}
        disabled={isFirstPage}
        onClick={onFirst}
      />
      <ToolbarButton
        aria-label="Previous page"
        icon={<ChevronLeft24Filled />}
        disabled={isFirstPage}
        onClick={onPrev}
      />
      <Label style={{ minWidth: 80, textAlign: 'center' }}>
        {page} of {pageCount}
      </Label>
      <ToolbarButton
        aria-label="Next page"
        icon={<ChevronRight24Filled />}
        disabled={isLastPage}
        onClick={onNext}
      />
      <ToolbarButton
        aria-label="Last page"
        icon={<ArrowNext24Filled />}
        disabled={isLastPage}
        onClick={onLast}
      />
      {children}
    </Toolbar>
  );
};

export default PaginationBar;
